// extracted by mini-css-extract-plugin
export default {"recos":"S6-z","productCardOverride":"T6-z","rowHasBadge":"U6-z"};